import { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface ContextoKpiTileProps {
  icon: ReactNode;
  label: string;
  value: string;
  /** Classes de cor do tile (borda + fundo + texto). */
  tone: string;
  /** Classes de cor do selo do ícone. */
  iconTone: string;
  /** Realça o tile com um anel (a cor do ring vem embutida no `tone`). */
  highlight?: boolean;
  /** Sobrescreve a cor do valor (ex.: vermelho para rentabilidade negativa). */
  valueClass?: string;
}

/**
 * Tile de KPI "de contexto": card tingido com selo do ícone à esquerda. Usado nos
 * cartões de contexto (AP, Compra) acima dos formulários — distinto do
 * NumberKpiCard (branco, ícone no canto) das páginas de listagem.
 */
export function ContextoKpiTile({
  icon,
  label,
  value,
  tone,
  iconTone,
  highlight,
  valueClass,
}: ContextoKpiTileProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-3 rounded-xl border p-3 sm:p-4",
        tone,
        highlight && "ring-1",
      )}
    >
      <span className={cn("grid size-10 shrink-0 place-items-center rounded-lg", iconTone)}>
        {icon}
      </span>
      <div className="flex min-w-0 flex-col">
        <span className="text-[11px] font-medium uppercase tracking-wider opacity-70">{label}</span>
        <span className={cn("text-lg font-bold leading-tight sm:text-xl", valueClass)}>
          {value}
        </span>
      </div>
    </div>
  );
}
